export const LIST_CARDS='LIST_CARDS'
export const LIST_CARDS_SUCCESS='LIST_CARDS_SUCCESS'
export const LIST_CARDS_ERROR='LIST_CARDS_ERROR'

export const ListCards = (data) => ({
    type: LIST_CARDS,
    payload: data
})